import classNames from "classnames";
import React from "react";
import { Radio } from "..";
import classes from "./RadioGroup.module.scss";

export const RadioGroup = ({ groupLabel, children }) => {
  return (
    <div className={classes["wrapper"]}>
      <div className={classes["label-text"]}>{groupLabel}</div>
      <div className={`d-flex ${classes["children-container"]}`}>
        {children}
      </div>
    </div>
  );
};

export const RadioGroupList = React.forwardRef(
  ({ label, list, onChange, name, value, onBlur }, ref) => {
    return (
      <div
        className={classNames(classes["wrapper"], "mb-4")}
        name={name}
        ref={ref}
      >
        <div className={classes["label-text"]}>{label}</div>
        <div className={`d-flex ${classes["children-container"]}`}>
          {list.map((item, i) => {
            return (
              <Radio
                name={name}
                key={i}
                label={item.title}
                onChange={() => {
                  onBlur && onBlur();
                  onChange(item.value);
                }}
                onBlur={onBlur}
                checked={value === item.value}
              />
            );
          })}
        </div>
      </div>
    );
  }
);
